import React from "react";

import { StyledTitle } from "./styles";
import { IProps } from "./interfaces";

const Title = ({ children, ...props }: IProps) => (
    <StyledTitle {...props}>{children}</StyledTitle>
);

export default Title;
